export default __webpack_public_path__ + "static/media/qtu.738d93a8.svg";